export default function useDayDifference() {
  const calculateDayDifference = (date1: string, date2: string) => {
    const date1StartOfDay = new Date(date1)
    const date2StartOfDay = new Date(date2)
    date1StartOfDay.setHours(0, 0, 0, 0)
    date2StartOfDay.setHours(0, 0, 0, 0)

    const diffTime = Math.abs(
      date2StartOfDay.getTime() - date1StartOfDay.getTime()
    )
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  }

  return {
    calculateDayDifference,
  }
}
